import { createFileRoute, redirect } from '@tanstack/react-router';
import { getToken } from '@/utils/authToken.ts';
import ManagerLayout from '@/layouts/ManagerLayout.tsx';
import client from '@/utils/apolloClient.ts';
import { myCompanyDocument } from '@social-garden/api/documents/company.ts';
import { myBrandsDocument } from '@social-garden/api/documents/brand.ts';
import { managerDocument } from '@social-garden/api/documents/manager.ts';
import RootLayoutSuspenseFallback from '@/components/RootLayoutSuspenseFallback.tsx';

export const Route = createFileRoute('/_manager')({
  beforeLoad: ({ location }) => {
    const token = getToken();
    if (!token) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  loader: async () => {
    const {
      data: { whoAmI },
    } = await client.query({ query: managerDocument });

    const {
      data: { myCompany },
    } = await client.query({ query: myCompanyDocument });

    const {
      data: { myBrands },
    } = await client.query({ query: myBrandsDocument });

    if (whoAmI.__typename !== 'ManagerAuthenticatable') {
      throw new Error('Authenticated user is not a manager!');
    }

    return {
      manager: whoAmI,
      company: myCompany,
      brands: myBrands,
    };
  },
  component: ManagerLayout,
  pendingComponent: RootLayoutSuspenseFallback,
  pendingMs: 0,
});
